<template>
    <header class="app-header">
        <a href="/" class="app-header__logo bg-success p-0" :title="title">
			<img src="/assets/img/logo-panel.png">
		</a>
        <a
			class="app-sidebar__toggle"
			href="javascript:"
			data-toggle="sidebar"
			aria-label="Hide Sidebar"
			v-on:click="onToggleSideBar"
		></a>
        <ul class="app-nav">
            <li class="app-search">
				<input class="app-search__input" type="search" placeholder="Busca">
				<button class="app-search__button">
					<i class="fa fa-search"></i>
				</button>
			</li>
            <app-notifications user-id="userId"></app-notifications>
            <app-header-profile></app-header-profile>
        </ul>
    </header>
</template>

<script>
    import Notification from './NotificationComponent';
    import HeaderProfile from './HeaderProfileComponent';

    export default {
        components: {
            'app-notifications': Notification,
            'app-header-profile': HeaderProfile
        },
        props: {
			title: String
		},
        methods: {
			onToggleSideBar: () => {
				if (cash('.sidenav-toggled').length) {
					localStorage.setItem('menuState', 'show');
				} else {
					localStorage.setItem('menuState', 'hide');
				}
			}
		}
    }
</script>